import axios from 'axios';

const api = axios.create({
  baseURL: 'https://acolitosdodivino.com.br/api',
  //baseURL: 'http://localhost:5555',
});

// Handler global para sessão expirada
let onSessionExpired = null;
export function registerSessionExpiredHandler(fn) {
  onSessionExpired = fn;
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.method && config.method.toLowerCase() === 'get') {
    config.params = {
      ...config.params,
      _t: Date.now()
    };
  }
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {

      const currentPath = window.location.pathname;
      const isLoginPage = currentPath === '/' || currentPath === '/login' ||
        currentPath === '/forgot-password' || currentPath === '/reset-password';

      if (!isLoginPage && onSessionExpired) {
        onSessionExpired();
      }
    }
    return Promise.reject(error);
  }
);

export default api;